import {
  Button, Dialog, DialogContent, DialogTitle,
} from '@mui/material';
import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  dialogButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1em',
    padding: '1em',
  },
}));

export interface TranscriptionDialogWrapperProps extends PropsWithChildren {
  handleClose: () => void;
  currentStep?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

const TranscriptionDialogWrapper: React.FC<TranscriptionDialogWrapperProps> = ({
  handleClose,
  currentStep,
  open,
  setOpen,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <Dialog onClose={() => setOpen(false)} open={open}>
      <DialogContent>
        <DialogTitle>{t('home.input.dialog.close.title')}</DialogTitle>
        <div className={classes.dialogButtons}>
          <Button
            variant="contained"
            id={`btn_transcription_close_yes_${currentStep}`}
            onClick={() => {
              setOpen(false);
              handleClose();
            }}
          >
            {t('home.input.dialog.close.yes')}
          </Button>
          <Button
            variant="contained"
            id="btn_transcription_close_no"
            onClick={() => setOpen(false)}
          >
            {t('home.input.dialog.close.no')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TranscriptionDialogWrapper;
